'use client'

import PointList from "@/app/pointexchange/_list";
import SectionTitle from "@/components/etc/section_title";
import { useTranslations } from "next-intl";
import { useEffect } from "react";

export default function PointEvent({ isSwipe }: {  isSwipe?: boolean }){
    const t = useTranslations("Text")
    const p = useTranslations("PageTitle")
    
    return (
        <>
        <div>
            <div className="page-title p-t-0 p-b-15">
                <span className={`--menu point-event`}></span>
                {t("포인트")} <b style={{color:"var(--text"}}>{t("전환")}</b>
            </div>
            <SectionTitle shortCut={`/pointexchange/sponmd/`} ><span>{p("스폰상품")}</span></SectionTitle>
            <div className={`mainPage point`}>
                <PointList type={1} sideBoard isSwipe />
            </div>
        </div>
        </>
    )
}